import {DataObjectId} from 'yougile-model'

export interface DealActivityItemBase {
  id: DataObjectId
  from: DataObjectId
  type: DealActivityType
  timestamp: number
}

export type DealActivityType = 'deal' | 'note' | 'created' | 'moved'

export interface DealActivityCreatedItem extends DealActivityItemBase {
  type: 'created'
}

export interface DealActivityMovedItem extends DealActivityItemBase {
  type: 'moved'
  moved: {
    from?: DataObjectId
    to?: DataObjectId
  }
}

export interface DealActivityNoteItem extends DealActivityItemBase {
  type: 'note'
  text: string
}

export interface DealActivityDealItem extends DealActivityItemBase {
  type: 'deal'
  text: string
  deadline: number
  completed?: boolean
  completedModified?: number
  assigned?: DataObjectId[]
}

export type DealActivityItem =
  | DealActivityCreatedItem
  | DealActivityNoteItem
  | DealActivityDealItem
  | DealActivityMovedItem

export interface DealHubData {
  dealActivity?: {
    [key: DataObjectId]:
      | DealActivityCreatedItem
      | DealActivityNoteItem
      | DealActivityDealItem
    // DealActivityMovedItem - from ChatMessage
  }
}

export const isDealActivityDealItem = (
  obj?: DealActivityItem
): obj is DealActivityDealItem => {
  return obj?.type === 'deal'
}

export const isDealActivityNoteItem = (
  obj?: DealActivityItem
): obj is DealActivityNoteItem => {
  return obj?.type === 'note'
}

export const isDealActivityCreatedItem = (
  obj?: DealActivityItem
): obj is DealActivityCreatedItem => {
  return obj?.type === 'created'
}

export const isDealActivityMovedItem = (
  obj?: DealActivityItem
): obj is DealActivityMovedItem => {
  return obj?.type === 'moved'
}
